/** Where a prompt goes, which also keys its draft and retries: one exact
 *  conversation, a new Denker chat, or Denker's current conversation. Never
 *  the viewed project: switching the view keeps the target and the draft. */
export type InputDestinationKey =
  | `conversation:${string}`
  | "denker-new"
  | "denker";

export function inputDestinationKey(route: {
  startNewConversation?: boolean;
  conversationId?: string | null;
}): InputDestinationKey {
  if (route.startNewConversation) return "denker-new";
  return route.conversationId
    ? `conversation:${route.conversationId}`
    : "denker";
}
